import { useState, useEffect } from 'react';
import { getPublicWebsiteConfig } from '../services/api/system';
import type { WebsiteConfig } from '../services/api/system';

export function useWebsiteConfig() {
  const [config, setConfig] = useState<WebsiteConfig>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPublicWebsiteConfig().then((data) => {
      setConfig(data);
      setLoading(false);
    }).catch(() => {
      setLoading(false);
    });
  }, []);

  return { config, loading };
}
